import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useMiscStore = defineStore('misc', () => {
  const ossURL = ref<string | null>(null)

  const setOssURL = (url: string | null) => {
    ossURL.value = url
  }

  const getOssURL = () => ossURL.value

  return {
    ossURL,
    setOssURL,
    getOssURL
  }
})